import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import axiosClient from 'api/axiosClient';

export default function ActionConfirmCard({ message, conversationId, onResolved }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  let proposal = null;
  try {
    proposal = JSON.parse(message.content ?? '{}');
  } catch {
    proposal = null;
  }

  if (!proposal?.id || proposal.status !== 'pending') {
    return null;
  }

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      await axiosClient.post(`/chat/conversations/${conversationId}/confirm-action`, {
        proposalId: proposal.id
      });
      onResolved?.(proposal.id, 'confirmed');
    } catch (err) {
      setError(err?.response?.data?.message ?? t('chat.actionConfirmError'));
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async () => {
    setLoading(true);
    setError(null);
    try {
      await axiosClient.post(`/chat/conversations/${conversationId}/cancel-action`, {
        proposalId: proposal.id
      });
      onResolved?.(proposal.id, 'cancelled');
    } catch (err) {
      setError(err?.response?.data?.message ?? t('chat.actionCancelError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mb: 1.5, px: 1 }}>
      <Box
        sx={{
          p: 1.5,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'warning.main',
          bgcolor: 'background.paper'
        }}
      >
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          {t('chat.actionConfirmTitle')}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {proposal.summaryHuman}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="contained" disabled={loading} onClick={handleConfirm}>
            {t('chat.actionConfirm')}
          </Button>
          <Button size="small" variant="outlined" disabled={loading} onClick={handleCancel}>
            {t('chat.actionCancel')}
          </Button>
        </Stack>
        {error && (
          <Typography variant="caption" color="error" display="block" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
